import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { supabase } from '../utils/supabaseClient';
import { useAuth } from '../Context/TokenContext';
import logo from '../images/stacktalent-708X214.jpg';

function HomeHeader() {
    const { session } = useAuth();
    const navigate = useNavigate();

    const handleLogin = () => navigate('/login');

    const handleLogout = async () => {
        await supabase.auth.signOut();
        window.location.href = '/';
    };

    return (
        <header>
            <nav className="navbar navbar-expand-sm navbar-toggleable-sm navbar-light bg-white border-bottom box-shadow">
                <div className="container-fluid container-index-w234">
                    <Link className="navbar-brand" to="/">
                        <img src={logo} className="csshomelogo" alt="Stacktalent logo" />
                    </Link>

                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target=".navbar-collapse"
                        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon" />
                    </button>

                    <div className="navbar-collapse collapse d-sm-inline-flex justify-content-between">
                        <div className="navbar-tu-inn ms-auto">
                            <ul className="navbar-nav flex-grow-1">
                                <li className="nav-item">
                                    <Link className="nav-link text-dark" to="/">Find Jobs</Link>
                                </li>
                                {session ? (
                                    <>
                                        <li className="nav-item">
                                            <Link className="nav-link text-dark" to="/candidate/profile">Profile</Link>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-link text-dark" href="#" onClick={(e) => { e.preventDefault(); handleLogout(); }}>
                                                Log Out
                                            </a>
                                        </li>
                                    </>
                                ) : (
                                    <li className="nav-item">
                                        <a className="nav-link text-dark" href="#" onClick={(e) => { e.preventDefault(); handleLogin(); }}>
                                            Sign In
                                        </a>
                                    </li>
                                )}
                                <li className="nav-item">
                                    <a className="nav-link text-dark" href="https://business.stacktalent.com.au">
                                        Employers / Post Job
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </nav>
        </header>
    );
}

export default HomeHeader;
